import { resolve } from 'path';
import { InvoicesService, IInvoice, TwinfieldService } from "../../services/index";
import * as moment from "moment";
import * as _ from "lodash";

class QuotationsDashboardController implements ng.IComponentController {

    /** Injectables */

    private sortType: string;

    private startDate: any;
    private endDate: any;
    private invoices: IInvoice[];
    private currentInvoice: IInvoice;
    private moment: any;
    private invoicesTotalAmount: number;
    private twinfieldTotalAmount: number;
    private proformaInvoicesOnly: boolean;

    constructor(
        private InvoicesService: InvoicesService,
        private $stateParams: ng.ui.IStateParamsService,
        private $scope: ng.IScope,
        private TwinfieldService: TwinfieldService
    ) {
        'ngInject';
    }

    public $onInit = () => {

        /** Set return URI */

        this.TwinfieldService.setTwinfieldRedirectUri();

        this.proformaInvoicesOnly = this.$stateParams['proformaInvoicesOnly'];

        this.sortType = 'account.name';
        this.moment = require('moment');

        this.startDate = this.moment().startOf('isoweek').toDate();
        this.endDate = this.moment().endOf('isoweek').toDate();

        if (this.proformaInvoicesOnly) {
            this.getInvoices();
        }
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    prevWeek() {
        this.startDate = this.moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(-7, 'day').toDate();
    }
    
    nextWeek() {
        this.startDate = this.moment(this.startDate).add(7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(7, 'day').toDate();
    }

    getInvoices() {
        this.InvoicesService.customGet('makeinvoices', {from: this.startDate, till: this.endDate, proformaInvoicesOnly: this.proformaInvoicesOnly}).then((result: any) => {
            this.invoices = result;
            this.checkForUnpaid();
            this.getTotalAmount();
        });
    }

    selectInvoice(item) {
        this.currentInvoice = item;
    }

    checkForUnpaid() {
        this.invoices.forEach(invoice => {
            invoice.lines.forEach(line => {
                if (line.count > 0 && (line.totalAmount == 0 || line.totalAmount == undefined || line.amountPerUnit == 0 || line.amountPerUnit == undefined)) {
                    invoice.hasUnpaid = true;
                }
            });
        });
    }

    getTotalAmount() {
        this.invoicesTotalAmount = 0;
        this.twinfieldTotalAmount = 0;
        this.invoices.forEach(i => {
            this.invoicesTotalAmount += i.totalAmount;
            if (i.twinfieldNumber) {
                this.twinfieldTotalAmount += i.totalAmount;
            }
        });
    }

    updateInvoice(action) {
        switch (action) {
            case 'delete': {
                this.InvoicesService.delete(this.currentInvoice.id).then(() => {
                    this.invoices = this.invoices.filter(i => i.id != this.currentInvoice.id);
                    this.currentInvoice = null;
                });
                break;
            }
            case 'send': {
                this.InvoicesService.customPost(this.currentInvoice.id + '/send', null).then((data) => {
                    //this.currentInvoice = data;
                    _.find(this.invoices, {"id": this.currentInvoice.id }).twinfieldNumber = data.twinfieldNumber;
                });
                break;
            }
        }
    }
}

export const quotationsDashboardComponent : ng.IComponentOptions = {
    controller : QuotationsDashboardController,
    template :require('./quotations.dashboard.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/quotations/quotations.dashboard.component.ts